export default __webpack_public_path__ + "static/media/DSC_0539.5ddd2444.webp";